import React, { useState } from 'react'
import { TableRow, TableCell } from '@material-ui/core'
import Input from '../../generic/Input'
import Button from '../../generic/Button'
import { requestAPI } from '../../data/api.js'

export default function AddImageSupplierPattern(props) {
	const { clientId, fetchPatternDomains } = props
	const [pattern, setPattern] = useState('')
	const [domains, setDomains] = useState('')

	const addPattern = async () => {
		await addImageSupplierPattern(
			clientId,
			pattern,
			domains,
		)
		await fetchPatternDomains()
		setPattern('')
		setDomains('')
	}

	return (
		<TableRow>
			<TableCell>
				<Input
					placeholder='\yAFP\y|\yAP\y'
					value={pattern}
					onChange={e => setPattern(e.target.value)}
				/>
			</TableCell>
			<TableCell>
				<Input
					placeholder='.com,facebook.com'
					value={domains}
					onChange={e => setDomains(e.target.value)}
				/>
			</TableCell>
			<TableCell padding='none'>
				<Button onClick={addPattern} disabled={(pattern === '') || (domains === '')}>Add</Button>
			</TableCell>
		</TableRow>
	)
}

function addImageSupplierPattern(clientId, pattern, domains) {
	return requestAPI('/include-domains/image-supplier-patterns', 'POST', {
		clientId,
		pattern,
		domains,
	})
}
